import { capitalizeName, sanitizeName } from '../../../libs/strings'
import i18n from '../../../translations/i18n'
import { Application } from '../../../types/applications'
import { formatToReadableDate } from '../../../utils/dates'

const handleApplicationNameAndCreatedAt = (
  application: Application,
  t: i18n.TFunction
) => {
  const {
    data: { name: rawName },
    createdAt
  } = application
  const sanitizedName = sanitizeName(rawName) || ''
  const nameLength = sanitizedName?.length
  const nameWithLengthHandled =
    nameLength > 30
      ? `${sanitizedName.slice(0, 30)}...`
      : sanitizedName.slice(0, 30)
  const name = capitalizeName(nameWithLengthHandled)

  const readableCreatedAtDate = formatToReadableDate(createdAt, 'dd.mm.')
  const at = t('calendar.at')
  const readableCreatedAtTime = formatToReadableDate(createdAt, 'HH.MM')
  const createdAtString = `${readableCreatedAtDate} ${at} ${readableCreatedAtTime}`

  return { name, createdAtString }
}

export { handleApplicationNameAndCreatedAt }
